import { SegmentType, Exchange } from 'modules/Search/constants';

export const decomposeExchangeToken = (
  exchangeToken: string,
  separator: '-' | '|' | '_TOKEN_' = '|',
): { segment: SegmentType; token: string } => {
  const [segment, token] = (exchangeToken?.split(
    separator,
  ) || []) as [segment: SegmentType, token: string];

  return { segment, token };
};

export const decomposeInstrumentKey = (
  instrumentKey: string,
  separator: '-' | '|' = '|',
): { segment: SegmentType; token: string } => {
  const [segment, token] = (instrumentKey?.split(
    separator,
  ) || []) as [segment: SegmentType, token: string];

  return { segment, token };
};

export const decomposeSegment = (
  segment: SegmentType,
): { exchange: Exchange; series: Series } => {
  const [exchange, series] = (segment.split('_') || []);

  return { exchange: exchange as Exchange, series: series as Series };
};

export const getTimestampFromDataSchema = ({
  expiryYear,
  expiryMonth,
  expiryDate,
}: DataSchema) =>
  new Date(`20${expiryYear}-${expiryMonth}-${expiryDate}`).getTime();
